import React from 'react';
import MultiItemSelection from 'sulu-admin-bundle/components/MultiItemSelection';
import {arrayMove} from 'sulu-admin-bundle/utils';

class SortableValues extends React.Component {
    constructor(props) {
        super(props);

        const initialItems = props.value || [];
        const selectedValues = initialItems.map((item) => item.value);

        this.state = {
            items: initialItems,
            options: this.getOptions().filter(
                (option) => option.value === 'trenner' || !selectedValues.includes(option.value)
            ),
        };

        if(typeof props.schemaOptions.values === 'undefined') {
            console.log('fields collection is empty at field: ' + props.label );
        }
    }

    getOptions = () => this.props.schemaOptions?.values?.value.map(function(field) {
            return {value: field.name, label: field.title};
        }) ?? [];

    getOptionByValue = (val) => this.getOptions().find(({value}) => value === val);

    handleItemsSorted = (oldIndex, newIndex) => {
        const newItems = arrayMove(this.state.items, oldIndex, newIndex);
        this.setState({items: newItems});
        this.props.onChange(newItems);
    };

    handleRemove = (indexToRemove) => {
        const removedItem = this.state.items[indexToRemove];

        const newItems = this.state.items.filter((_, index) => index !== indexToRemove);

        const newOptions =
            removedItem.value === 'trenner'
                ? this.state.options
                : [...this.state.options, removedItem];

        this.setState({
            items: newItems,
            options: newOptions,
        });

        this.props.onChange(newItems);
    };

    handleAddItem = (optionValue) => {
        const option = this.getOptionByValue(optionValue);

        if (!option) return;

        if (option.value !== 'trenner' && this.state.items.some((item) => item.value === option.value)) {
            return;
        }

        const newItems = [...this.state.items, option];

        const newOptions =
            option.value === 'trenner'
                ? this.state.options
                : this.state.options.filter((item) => item.value !== option.value);

        this.setState({
            items: newItems,
            options: newOptions,
        });

        this.props.onChange(newItems);
    };

    render() {
        const Item = MultiItemSelection.Item;

        return (
            <MultiItemSelection
                label=""
                leftButton={{
                    icon: 'su-plus-circle',
                    onClick: this.handleAddItem,
                    options: this.state.options,
                }}
                onItemsSorted={this.handleItemsSorted}
                onItemRemove={this.handleRemove}
            >
                {this.state.items.map((item, index) => (
                    <Item
                        key={index}
                        id={index}
                        index={index + 1}
                    >
                        <div style={{height: '40px', lineHeight: '40px'}}>
                            {item.label}
                        </div>
                    </Item>
                ))}
            </MultiItemSelection>
        );
    }
}

export default SortableValues;